import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import { OnboardingProcessesIcon, OnboardingTrackingIcon } from "@icarius-icons/";
import paths from "@icarius-router/paths";
import { useSelector } from "react-redux";
import { getUserData } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {
    const { level } = useSelector(getUserData);

    const data = [
        {
            name: getLocalizedString("onboardingProcesses"),
            icon: <OnboardingProcessesIcon />,
            path: paths.onboardingProcesses,
        },
        {
            name: level === "E" ? getLocalizedString("onboardingTracking") : getLocalizedString("myOnboardingTasks"),
            icon: <OnboardingTrackingIcon />,
            path: paths.onboardingTracking,
        },
    ];

    return <ScreenSelector title={getLocalizedString("onboardingScreenSelector")} data={data} />;
};

export default Index;
